import { Component, Optional } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-compass',
    templateUrl: 'dialog-compass.component.html',
    styleUrls: ['./dialog-compass.component.css'],
    standalone: false
})

  export class DialogCompassComponent {
    constructor(@Optional() public dialogRef: MatDialogRef<DialogCompassComponent>) {}

  closeDialog() {
    this.dialogRef.close();
  }
}
